<template>
  <div class="page-title">
    <div class="row">
      <div class="col-sm-6 col-12">
        <h2> All Rides</h2>
      </div>
    </div>
  </div>

  <div class="card height-equal-2">
    <div class="card-header card-no-border pb-0">
      <ul class="nav nav-tabs" id="icon-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="all-rides-tab" data-bs-toggle="tab"
             href="#all-rides" role="tab" aria-controls="all-rides" aria-selected="true">
            <i class="fa-solid fa-taxi text-primary"></i>
            All Rides
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="dispatched-rides-tab" data-bs-toggle="tab"
             href="#dispatched-rides" role="tab" aria-controls="dispatched-rides" aria-selected="false">
            <i class="fa-solid fa-user-tie text-secondary"></i>
            Dispatched Rides
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="ordered-rides-tab" data-bs-toggle="tab"
             href="#ordered-rides" role="tab" aria-controls="ordered-rides" aria-selected="false">
            <i class="fa-solid fa-mobile-screen-button text-success"></i>
            Ordered Rides
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content" id="icon-tabContent">
        <div class="tab-pane fade show active" id="all-rides" role="tabpanel" aria-labelledby="icon-home-tab">
          <DataTable
              :ajax="{ url: ridesUrl}"
              ref="allRides" class="table-responsive display" :columns="allColumnDefinition"/>
        </div>

        <div class="tab-pane fade" id="dispatched-rides" role="tabpanel" aria-labelledby="profile-icon-tabs">
          <DataTable
              :ajax="{ url: dispatchedRidesUrl}"
              ref="dispatchedRides" class="table-responsive display" :columns="columnDefinition"/>
        </div>

        <div class="tab-pane fade" id="ordered-rides" role="tabpanel" aria-labelledby="contact-icon-tab">
          <DataTable
              :ajax="{ url: orderedRidesUrl}"
              ref="orderedRides" class="table-responsive display" :columns="columnDefinition"/>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {potentialUndefinedColumn, rideStatus, rideType, userDetailsWithThumbnail} from "../utility/DatatableRenderer";
import {newEntityId} from '../globals.js';

DataTable.use(DataTablesCore);

const props = defineProps({
  serviceProviderId: { type: String, default: newEntityId }
});

const ridesUrl = `/api/datatable/sp-all-rides/${props.serviceProviderId}`;
const dispatchedRidesUrl = `${ridesUrl}?type=DISPATCHED`;
const orderedRidesUrl = `${ridesUrl}?type=ORDERED`

// Define columns
const allColumnDefinition = [
  {
    title: "Driver", data: "driverName", render: (data, type, row) => {
      return userDetailsWithThumbnail(data, row, `/service-provider/${props.serviceProviderId}/driver/${row.id}`)
    }
  },
  {
    title: "Rider", data: "riderName", render: potentialUndefinedColumn
  },
  {data: "pickupAddress", title: 'Pickup Location', render: DataTablesCore.render.ellipsis(30, true) },
  {data: "destinationAddress", title: 'Destination', render: DataTablesCore.render.ellipsis(30, true)},
  {data: "status", title: 'Status', render: rideStatus},
  {data: "type", title: 'Booking Type', render: rideType},
  {title: 'Actions', orderable: false, searchable: false, render: (data, type, row) => {
    return `<a class="btn btn-outline-primary"" data-id="${row.id}"
        href="/service-provider/${props.serviceProviderId}/ride/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
    }}
];

const columnDefinition = [
  {
    title: "Driver", data: "driverName", render: (data, type, row) => {
      return userDetailsWithThumbnail(data, row, `/service-provider/${props.serviceProviderId}/driver/${row.id}`)
    }
  },
  {
    title: "Rider", data: "riderName", render: (data, type, row) => {
      return userDetailsWithThumbnail(data, row, `/rider/${row.id}`)
    }
  },
  {data: "pickupAddress", title: 'Pickup Location', render: DataTablesCore.render.ellipsis(30, true) },
  {data: "destinationAddress", title: 'Destination', render: DataTablesCore.render.ellipsis(30, true)},
  {data: "status", title: 'Status', render: rideStatus},
  {title: 'Actions', orderable: false, searchable: false, render: (data, type, row) => {
      return `<a class="btn btn-outline-primary" data-id="${row.id}"
        href="/service-provider/${props.serviceProviderId}/ride/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
    }}
];
</script>